import { Button, HStack } from '@montel/montelpro-shared-components-v2';
import { RequestStatus } from 'types/RequestStatus';

export const AssignToCompanyFooter: React.FunctionComponent<{
	onSubmitted: () => void;
	onCloseModal: () => void;
	postAssignToCompanyStatus: RequestStatus;
	buttonText: string;
	isSubmitDisabled?: boolean;
}> = ({
	onSubmitted,
	onCloseModal,
	postAssignToCompanyStatus,
	buttonText,
	isSubmitDisabled,
}) => (
	<HStack gap="md">
		<Button
			text={buttonText}
			size="md"
			type="submit"
			isLoading={postAssignToCompanyStatus === RequestStatus.LOADING}
			loadingText="Updating..."
			onClick={onSubmitted}
			isDisabled={isSubmitDisabled}
		/>
		<Button
			text="Cancel"
			size="md"
			variant="secondary"
			onClick={onCloseModal}
		/>
	</HStack>
);
